// src/pages/atributos/EliminarValorAtributo.js
import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

function EliminarValorAtributo({ mostrar, valor, tipo, eliminar, cancelar }) {
    const [loading, setLoading] = useState(false)

    const handleClose = () => {
        cancelar()
    }

    const handleEliminar = async () => {
        setLoading(true)
        try {
            await eliminar()
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    if (!valor) return null

    return (
        <Modal show={mostrar} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-trash text-danger me-2"></i>
                    Eliminar valor
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="danger">
                    <i className="fa fa-exclamation-triangle me-2"></i>
                    Está a punto de eliminar el valor <strong>"{valor.nombre}"</strong>
                    {tipo && <> del tipo de atributo <strong>"{tipo.nombre}"</strong></>}.
                </Alert>

                <Alert variant="warning">
                    <i className="fa fa-info-circle me-2"></i>
                    <strong>Importante:</strong> Si este valor está siendo usado en productos,
                    no podrá eliminarse. Considere desactivarlo en su lugar.
                </Alert>

                <p className="mb-0">
                    ¿Está seguro que desea eliminar este valor?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose} disabled={loading}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={handleEliminar} disabled={loading}>
                    {loading ? (
                        <>
                            <i className="fa fa-spinner fa-spin me-2"></i>
                            Eliminando...
                        </>
                    ) : (
                        <>
                            <i className="fa fa-trash me-2"></i>
                            Eliminar
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarValorAtributo